{
  "layouts": {
    "type": "SingleLayoutData",
    "componentLayout": {
      "type": "ComponentLayout",
      "hidden": false,
      "minWidth": {
        "type": "px",
        "value": 0
      },
      "minHeight": {
        "type": "px",
        "value": 0
      },
      "width": {
        "type": "auto"
      },
      "height": {
        "type": "auto"
      }
    },
    "containerLayout": {
      "type": "GridContainerLayout",
      "rows": [
        {
          "type": "fr",
          "value": 1
        }
      ],
      "columns": [
        {
          "type": "fr",
          "value": 1
        }
      ]
    },
    "itemLayout": {
      "type": "GridItemLayout",
      "margins": {
        "left": {
          "type": "px",
          "value": 0
        },
        "right": {
          "type": "px",
          "value": 0
        },
        "top": {
          "type": "px",
          "value": 0
        },
        "bottom": {
          "type": "px",
          "value": 0
        }
      },
      "gridArea": {
        "rowStart": 1,
        "columnStart": 1,
        "rowEnd": 2,
        "columnEnd": 2
      },
      "alignSelf": "stretch",
      "justifySelf": "stretch"
    }
  }
}
